import { render, staticRenderFns } from "./VideoWidget.vue?vue&type=template&id=0294a96e&scoped=true"
import script from "./VideoWidget.vue?vue&type=script&lang=js"
export * from "./VideoWidget.vue?vue&type=script&lang=js"
import style0 from "./VideoWidget.vue?vue&type=style&index=0&id=0294a96e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0294a96e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0294a96e')) {
      api.createRecord('0294a96e', component.options)
    } else {
      api.reload('0294a96e', component.options)
    }
    module.hot.accept("./VideoWidget.vue?vue&type=template&id=0294a96e&scoped=true", function () {
      api.rerender('0294a96e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/viewer/templateWidgets/VideoWidget.vue"
export default component.exports